import { render, staticRenderFns } from "./LicenseTypeIframe.vue?vue&type=template&id=556b44d5&scoped=true&"
import script from "./LicenseTypeIframe.vue?vue&type=script&lang=ts&"
export * from "./LicenseTypeIframe.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseTypeIframe.vue?vue&type=style&index=0&id=556b44d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b44d5",
  null
  
)

export default component.exports